import { Grid, styled } from '@mui/material';

export const StyledGrid = styled(Grid)`
  background-color: whitesmoke;
  margin-bottom: 5px;
`;
